import React from 'react';
import { useScoreboard } from './context/ScoreboardContext';

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
};

const TeamInferiority = ({ isLiveView = false }) => {
  const {
    homeTeamInferiorityTime,
    awayTeamInferiorityTime,
    homePenalties,
    awayPenalties,
    showTeamInferiority
  } = useScoreboard();

  // Don't render if feature is disabled
  if (!showTeamInferiority) {
    return null;
  }

  // Don't render if both teams have no inferiority time OR if no team has more than 1 penalty
  if ((homeTeamInferiorityTime === 0 && awayTeamInferiorityTime === 0)) {
    return null;
  }


  if (isLiveView) {
   return null; 
  }
  // TODO: LiveView implementation - currently commented out for later use
  /*
  if (isLiveView) {
    return (
        <div className="grid grid-cols-[minmax(0,0.8fr),minmax(0,0.8fr),minmax(0,0.8fr)] min-h-[8vh] max-h-[8vh]" 
             style={{ backgroundColor: 'rgba(0,0,0,0.3)' }}>
          {/* Home Team Inferiority Time *\/}
          <div className="flex-1 flex flex-col items-center justify-center">
            <div className="flex items-center justify-end w-full leading-tight whitespace-nowrap">
              <span className="text-[6vh] font-bold text-white font-chivo leading-none">
                {homeTeamInferiorityTime > 0 ? formatTime(homeTeamInferiorityTime) : ''}
              </span>
            </div>
          </div>
          
          {/* Center Label *\/}
          <div className="flex items-center justify-center">
            <span className="text-[3vh] font-bold text-white font-chivo leading-none">
              INFERIORITY
            </span>
          </div>
          
          {/* Away Team Inferiority Time *\/}
          <div className="flex-1 flex flex-col items-center justify-center">
            <div className="flex items-center justify-start w-full leading-tight whitespace-nowrap">
              <span className="text-[6vh] font-bold text-white font-chivo leading-none">
                {awayTeamInferiorityTime > 0 ? formatTime(awayTeamInferiorityTime) : ''}
              </span>
            </div>
          </div>
        </div>
      );
    }
  */

  // Control Panel View
  return (
    
    <div>
      {/* PENALTIES Header */}
      <div className="grid grid-cols-[1fr,1fr] gap-[1vh] max-w-[40vh] mx-auto">
        {/* Home Team Inferiority Time */}
        <div className="flex flex-col items-center">
          <div className="text-[1.8vh] font-bold text-white mb-[0.5vh]">HOME</div>
          <div className="w-[12vh] h-[4vh] bg-white rounded border border-gray-300 flex items-center justify-center shadow-sm">
            <span className="text-[2.2vh] font-bold text-red-600">
              {homeTeamInferiorityTime > 0 ? formatTime(homeTeamInferiorityTime) : '--:--'}
            </span>
          </div>
        </div>
        
        {/* Away Team Inferiority Time */}
        <div className="flex flex-col items-center">
          <div className="text-[1.8vh] font-bold text-white mb-[0.5vh]">AWAY</div>
          <div className="w-[12vh] h-[4vh] bg-white rounded border border-gray-300 flex items-center justify-center shadow-sm">
            <span className="text-[2.2vh] font-bold text-red-600">
              {awayTeamInferiorityTime > 0 ? formatTime(awayTeamInferiorityTime) : '--:--'}
            </span>
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default TeamInferiority;
